/* ============================================================
   les Enfants Sauvages — Page de lancement (style Ulule)
   assets/les-lancement.js  (v18 — 2026-06-09)
   v18 : pop-up preuve sociale — intervalle porte a 19 s (~ +10 s) et
        rotation des 5 dernieres personnes (du plus recent au plus ancien,
        tri par date). Repli sur 5 prenoms si moins de 5 ventes reelles.
   v16 : panier refreshCart. v11 : jauge AGREGEE depuis les packs.
        Recalcul toutes les 2 min en re-fetchant la section packs.
   ============================================================ */
(function () {
  'use strict';

  if (window.__lesLpInit) return;
  window.__lesLpInit = true;

  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var THEME_ROLE = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || 'main';
  var IS_LIVE = THEME_ROLE === 'main' && !DESIGN;

  function showToast(message) {
    var el = document.getElementById('les-toast');
    if (!el) return;
    el.textContent = '';
    var check = document.createElement('span');
    check.className = 'les-toast__check';
    check.textContent = '✓';
    el.appendChild(check);
    el.appendChild(document.createTextNode(message));
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-on'); }, 3200);
  }

  function refreshCart() {
    var cd = document.getElementById('cart-drawer');
    var sec = cd ? cd.closest('.shopify-section') : null;
    var sid = sec ? sec.id.replace('shopify-section-', '') : '';

    function setCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = c.item_count; }); })
        .catch(function () { });
    }
    function renderDrawer(cb) {
      if (!sid) { if (cb) cb(); return; }
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html) {
            var t = document.createElement('div'); t.innerHTML = html;
            var f = t.querySelector('#cart-drawer'); var c = document.getElementById('cart-drawer');
            if (f && c) c.innerHTML = f.innerHTML;
          }
          if (cb) cb();
        })
        .catch(function () { if (cb) cb(); });
    }
    function openDrawer() { if (typeof window.openCart === 'function') { try { window.openCart(); } catch (e) { } } }

    setCount();
    renderDrawer(function () {
      openDrawer();
      setTimeout(function () { renderDrawer(); setCount(); }, 450);
    });
  }

  document.addEventListener('click', function (e) {
    var copy = e.target.closest && e.target.closest('[data-les-copy]');
    if (copy) {
      var url = window.location.href.split('?')[0];
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { showToast('Lien copie !'); })
          .catch(function () { showToast('Impossible de copier le lien'); });
      } else {
        showToast('Copie non disponible sur ce navigateur');
      }
      return;
    }

    var btn = e.target.closest && e.target.closest('[data-les-add]');
    if (!btn) return;
    var name = btn.getAttribute('data-pack-name') || 'Votre pack';
    var variantId = btn.getAttribute('data-variant-id');
    if (DESIGN) {
      showToast('Apercu editeur — ajout simule');
      return;
    }
    if (!variantId) {
      showToast('Pack de demonstration — reliez un produit pour activer l\'achat');
      return;
    }
    var old = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        btn.textContent = old;
        if (res.ok) {
          showToast(name + ' ajoute a votre panier');
          refreshCart();
        } else {
          showToast('Indisponible pour le moment');
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = old;
        showToast('Une erreur est survenue');
      });
  });

  function startCountdown() {
    function tick() {
      var el = document.querySelector('[data-les-jauge]');
      if (!el) return;
      var end = el.getAttribute('data-end');
      var target = document.querySelector('[data-les-days]');
      if (!end || !target) return;
      var endTs = Date.parse(end + 'T23:59:59');
      if (isNaN(endTs)) return;
      var days = Math.ceil((endTs - Date.now()) / 86400000);
      if (days < 0) days = 0;
      target.textContent = days;
    }
    tick();
    window.__lesCountdown = setInterval(tick, 60000);
  }

  function startStickyCta() {
    var bar = document.getElementById('les-sticky');
    if (!bar) return;
    var target = document.querySelector(bar.getAttribute('data-les-sticky-target') || '#les-packs');
    if (!target) return;
    function update() {
      var rect = target.getBoundingClientRect();
      if (rect.bottom < 0) { bar.classList.add('is-on'); }
      else { bar.classList.remove('is-on'); }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  function startScrollspy() {
    var links = document.querySelectorAll('.les-nav__link');
    if (!links.length || !('IntersectionObserver' in window)) return;
    var map = {};
    links.forEach(function (l) {
      var id = (l.getAttribute('href') || '').replace('#', '');
      if (id && document.getElementById(id)) map[id] = l;
    });
    var ids = Object.keys(map);
    if (!ids.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          map[en.target.id].classList.add('is-active');
        }
      });
    }, { rootMargin: '-25% 0px -60% 0px' });
    ids.forEach(function (id) { obs.observe(document.getElementById(id)); });
  }

  function tempsRelatif(dateStr) {
    var t = Date.parse(dateStr);
    if (isNaN(t)) return "a l'instant";
    var diff = Math.max(0, Date.now() - t);
    var min = Math.floor(diff / 60000);
    if (min < 1) return "a l'instant";
    if (min < 60) return 'il y a ' + min + ' min';
    var h = Math.floor(min / 60);
    if (h < 24) return 'il y a ' + h + ' h';
    return 'il y a ' + Math.floor(h / 24) + ' j';
  }

  function lesPackNames() {
    var seen = {}, out = [], els = document.querySelectorAll('.les-pack__name');
    for (var i = 0; i < els.length; i++) {
      var n = (els[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (n && !seen[n]) { seen[n] = 1; out.push(n); }
    }
    return out;
  }

  function getVentes() {
    var node = document.getElementById('les-ventes-data');
    var data = [];
    if (node) {
      try { data = JSON.parse(node.textContent) || []; } catch (e) { data = []; }
    }
    data = data.filter(function (v) { return v && v.prenom; });

    // Du plus recent au plus ancien (tri par date quand disponible)
    data.sort(function (a, b) {
      var ta = Date.parse(a && a.date); var tb = Date.parse(b && b.date);
      if (isNaN(ta) && isNaN(tb)) return 0;
      if (isNaN(ta)) return 1;
      if (isNaN(tb)) return -1;
      return tb - ta;
    });

    // On garde les 5 plus recents
    data = data.slice(0, 5);

    // Complement jusqu'a 5 avec des prenoms de repli si besoin
    var repli = ['Olivier', 'Nathalie', 'Robert', 'Stéphanie', 'Véronique'];
    for (var r = 0; data.length < 5 && r < repli.length; r++) {
      var dejaLa = false;
      for (var d = 0; d < data.length; d++) { if (data[d].prenom === repli[r]) { dejaLa = true; break; } }
      if (!dejaLa) data.push({ prenom: repli[r], produit: '', date: '' });
    }

    // Pack precis pour la preuve sociale : on nomme le pack pris (lu sur la page),
    // en remplacant le libelle generique (deodorant...) ou un produit vide.
    var packsDispo = lesPackNames();
    if (packsDispo.length) {
      var generique = /d[ée]odorant|^d[ée]o\b/i;
      for (var pk = 0; pk < data.length; pk++) {
        var actuel = data[pk].produit;
        if (!actuel || generique.test(actuel)) {
          var nomPack = packsDispo[pk % packsDispo.length];
          data[pk].produit = /^pack\b/i.test(nomPack) ? nomPack : ('pack ' + nomPack);
        }
      }
    }
    return { ventes: data, demo: false };
  }

  function startSocialProof() {
    var pop = document.getElementById('les-pop');
    if (!pop) return;
    var src = getVentes();
    if (!src.ventes.length) return;
    var i = 0;

    function render(v) {
      pop.textContent = '';
      var ico = document.createElement('span');
      ico.className = 'les-pop__icon';
      ico.textContent = '🛒';
      var txt = document.createElement('span');
      txt.className = 'les-pop__txt';
      var b = document.createElement('strong');
      b.textContent = v.prenom;
      txt.appendChild(b);
      txt.appendChild(document.createTextNode(' vient de commander'));
      if (v.produit) {
        txt.appendChild(document.createTextNode(' le '));
        var pr = document.createElement('strong');
        pr.textContent = v.produit;
        txt.appendChild(pr);
      }
      var time = document.createElement('span');
      time.className = 'les-pop__time';
      time.textContent = v.date ? tempsRelatif(v.date) : "a l'instant";
      txt.appendChild(time);
      pop.appendChild(ico);
      pop.appendChild(txt);
      pop.classList.add('is-on');
      setTimeout(function () { pop.classList.remove('is-on'); }, 4500);
    }

    function loop() {
      render(src.ventes[i % src.ventes.length]);
      i++;
      window.__lesPopT = setTimeout(loop, 19000);
    }
    window.__lesPopT = setTimeout(loop, 4000);
  }

  function startJaugeAggregate() {
    var jauge = document.querySelector('[data-les-jauge]');
    if (!jauge) return;
    var objectif = parseInt(jauge.getAttribute('data-les-objectif'), 10) || 0;

    function apply(cards) {
      if (!cards || !cards.length) return;
      var packs = 0, produits = 0;
      for (var i = 0; i < cards.length; i++) {
        var v = parseInt(cards[i].getAttribute('data-les-pack-ventes'), 10) || 0;
        var p = parseInt(cards[i].getAttribute('data-les-pack-produits'), 10) || 1;
        packs += v;
        produits += v * p;
      }
      var pct = objectif > 0 ? Math.round(produits * 100 / objectif) : 0;
      var pctBar = pct > 100 ? 100 : pct;
      var pctEl = jauge.querySelector('.les-jauge__pct');
      if (pctEl) pctEl.textContent = pct + '%';
      var fill = jauge.querySelector('.les-jauge__fill');
      if (fill) fill.style.width = pctBar + '%';
      var vn = jauge.querySelectorAll('[data-les-vendus]');
      for (var j = 0; j < vn.length; j++) vn[j].textContent = produits;
      var pn = jauge.querySelectorAll('[data-les-participations]');
      for (var k = 0; k < pn.length; k++) pn[k].textContent = packs;
    }

    apply(document.querySelectorAll('[data-les-pack-ventes]'));

    var packsEl = document.querySelector('[data-les-packs-id]');
    var packsId = packsEl ? packsEl.getAttribute('data-les-packs-id') : '';
    function refresh() {
      if (document.hidden) return;
      if (!packsId || DESIGN) { apply(document.querySelectorAll('[data-les-pack-ventes]')); return; }
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(packsId), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          apply(tmp.querySelectorAll('[data-les-pack-ventes]'));
        })
        .catch(function () { });
    }
    window.__lesJaugeAggT = setInterval(refresh, 120000);
  }

  function startYoutube() {
    var boxes = document.querySelectorAll('[data-les-yt]');
    if (!boxes.length) return;
    var apiLoading = false;
    function ensureApi(cb) {
      if (window.YT && window.YT.Player) { cb(); return; }
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (typeof prev === 'function') prev(); cb(); };
      if (!apiLoading) {
        apiLoading = true;
        var sc = document.createElement('script');
        sc.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(sc);
      }
    }
    function wireBar(box) {
      var bar = box.querySelector('.les-video__bar');
      if (!bar || bar._wired) return;
      bar._wired = true;
      bar.addEventListener('click', function (ev) {
        var p = box._yt;
        if (!p || !p.getDuration) return;
        var rect = bar.getBoundingClientRect();
        var ratio = (ev.clientX - rect.left) / rect.width;
        if (ratio < 0) ratio = 0;
        if (ratio > 1) ratio = 1;
        p.seekTo(ratio * (p.getDuration() || 0), true);
      });
    }
    function wireShield(box) {
      var sh = box.querySelector('.les-video__shield');
      if (!sh || sh._wired) return;
      sh._wired = true;
      sh.addEventListener('click', function () {
        var p = box._yt;
        if (!p || !p.getPlayerState) return;
        if (p.getPlayerState() === 1) { p.pauseVideo(); } else { p.playVideo(); }
      });
    }
    function wireSound(box) {
      var b = box.querySelector('.les-video__sound');
      if (!b || b._wired) return;
      b._wired = true;
      b.addEventListener('click', function () {
        var p = box._yt;
        if (!p || !p.isMuted) return;
        if (p.isMuted()) { p.unMute(); b.textContent = '🔊'; b.setAttribute('aria-label', 'Couper le son'); }
        else { p.mute(); b.textContent = '🔇'; b.setAttribute('aria-label', 'Activer le son'); }
      });
    }
    function startProgress(box) {
      var fill = box.querySelector('.les-video__barfill');
      clearInterval(box._pi);
      box._pi = setInterval(function () {
        var p = box._yt;
        if (!p || !p.getDuration) return;
        var d = p.getDuration() || 0, c = p.getCurrentTime() || 0;
        if (d > 0 && fill) fill.style.width = (c / d * 100) + '%';
      }, 250);
    }
    function create(box) {
      if (box.dataset.lesLoaded) { if (box._yt && box._yt.playVideo) box._yt.playVideo(); return; }
      box.dataset.lesLoaded = '1';
      var id = box.getAttribute('data-les-yt');
      var mount = document.createElement('div');
      box.insertBefore(mount, box.firstChild);
      wireBar(box); wireShield(box); wireSound(box);
      ensureApi(function () {
        box._yt = new YT.Player(mount, {
          videoId: id,
          playerVars: { autoplay: 1, mute: 1, controls: 0, playsinline: 1, rel: 0, modestbranding: 1, fs: 0, iv_load_policy: 3, disablekb: 1, loop: 1, playlist: id },
          events: {
            onReady: function (e) { try { e.target.mute(); e.target.playVideo(); } catch (x) { } startProgress(box); }
          }
        });
      });
    }
    if (!('IntersectionObserver' in window)) { boxes.forEach(create); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var box = en.target;
        if (en.isIntersecting) { create(box); }
        else if (box._yt && box._yt.pauseVideo) { try { box._yt.pauseVideo(); } catch (x) { } }
      });
    }, { threshold: 0.4 });
    boxes.forEach(function (b) { obs.observe(b); });
  }

  function placeNav() {
    var navSec = document.querySelector('.les-nav-section');
    if (!navSec) return;
    var vh = window.innerHeight || 800;
    var vw = window.innerWidth || 400;
    var max = 0;
    var sel = 'header,[class*="header" i],[class*="Header"],[id*="header" i],[class*="announce" i],[class*="ticker" i],[class*="utility" i],[class*="topbar" i],[class*="top-bar" i]';
    var cands;
    try { cands = document.querySelectorAll(sel); }
    catch (e) { cands = document.querySelectorAll('header,[class*="header"],[class*="announce"]'); }
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i];
      if (el === navSec || navSec.contains(el) || el.contains(navSec)) continue;
      var c = window.getComputedStyle(el);
      if (c.position === 'fixed' || c.position === 'sticky') {
        var r = el.getBoundingClientRect();
        if (r.top <= 2 && r.bottom > 4 && r.bottom < vh * 0.6 && r.width > vw * 0.5) {
          if (r.bottom > max) max = r.bottom;
        }
      }
    }
    if (max > 0) document.documentElement.style.setProperty('--les-header-h', Math.round(max) + 'px');
  }
  function watchHeader() {
    placeNav();
    var ticking = false;
    var settleT;
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(function () { placeNav(); ticking = false; }); }
      clearTimeout(settleT);
      settleT = setTimeout(placeNav, 180);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', placeNav);
    setTimeout(placeNav, 400);
    setTimeout(placeNav, 1200);
  }

  function init() {
    startCountdown();
    watchHeader();
    startJaugeAggregate();
    startYoutube();
    var previewOk = !!document.querySelector('#les-sticky[data-les-preview="true"]');
    if (DESIGN && !previewOk) return;
    startSocialProof();
    startStickyCta();
    startScrollspy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
